import moment from 'moment';
import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { postRequest } from 'src/utils/request';
import { forceString } from 'src/utils/datetime';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import messages from 'src/pages/TimeTrackingPage/messages';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import download from 'src/utils/download';
import useMessenger from 'src/utils/hooks/useMessenger';

const importTimeTracking = async (file: File) => {
  const payload = new FormData();
  payload.append('candidate_job_shift[csv_file]', file);

  const { data } = await postRequest<RequestSimplifiedData>(
    API.POST.importTimeTracking,
    payload,
    { headers: { 'content-type': 'multipart/form-data' } },
  );

  return data;
};

export const useImportTimeTracking = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  const messenger = useMessenger();

  return useMutation({
    mutationFn: importTimeTracking,
    onSuccess: (data) => {
      const now = forceString(
        moment(),
        moment.HTML5_FMT.DATETIME_LOCAL_SECONDS,
      );

      if (data) {
        download(data, `time-trackings-import-failures-${now}.csv`, 'text/csv');
        messenger.warning(
          formatMessage(messages.timeTrackingsImportFailedPart2),
        );
        messenger.warning(
          formatMessage(messages.timeTrackingsImportFailedPart1),
        );
      } else {
        client.invalidateQueries({
          queryKey: [QUERY_KEYS.CANDIDATE_JOB_SHIFTS],
        });
        handleSuccess(formatMessage(messages.timeTrackingsImported), 1000);
      }
    },
    onError: handleError,
  });
};
